import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SALES_SESSION_UNRETURNED_AMOUNT_COLUMNS } from '../../../../config/columns';
import Table from '../../../common/Table';
import { filterMethodCaseInsensitive } from '../../../../utils/filter-methods';
import { clearUnreturnedAmounts, getSalesSessionUnreturnedAmounts } from '../../../../actions/sales/UnreturnedAmount';

class UnreturnedAmountTable extends Component {
  static propTypes = {
    salesSessionId: PropTypes.number.isRequired,
    loading: PropTypes.bool.isRequired,
    dispatchGetSalesSessionUnreturnedAmount: PropTypes.func.isRequired,
    dispatchClearUnreturnedAmounts: PropTypes.func.isRequired,
    salesSessionUnreturnedAmount: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        externalTransactionId: PropTypes.string.isRequired,
        amount: PropTypes.number.isRequired,
      }),
    ),
  };

  static defaultProps = {
    salesSessionUnreturnedAmount: undefined,
  };

  constructor(props) {
    super(props);
    const { salesSessionId, dispatchGetSalesSessionUnreturnedAmount } = this.props;
    dispatchGetSalesSessionUnreturnedAmount({ salesSessionId });
  }

  componentWillUnmount() {
    const { dispatchClearUnreturnedAmounts } = this.props;
    dispatchClearUnreturnedAmounts();
  }

  render() {
    const { salesSessionUnreturnedAmount, loading } = this.props;

    return (
      <>
        <Table
          manual={false}
          columns={SALES_SESSION_UNRETURNED_AMOUNT_COLUMNS}
          data={salesSessionUnreturnedAmount}
          loading={loading}
          filterable
          defaultFilterMethod={filterMethodCaseInsensitive}
        />
        <br />
      </>
    );
  }
}

const mapStateToProps = ({ SalesUnit }) => {
  const salesSessionUnreturnedAmount = SalesUnit.UnreturnedAmount.getIn([
    'all',
    'content',
    'content',
  ]);
  const loading = SalesUnit.UnreturnedAmount.getIn(['all', 'loading']);
  return {
    loading,
    salesSessionUnreturnedAmount,
  };
};

const mapDispatchToProps = {
  dispatchGetSalesSessionUnreturnedAmount: getSalesSessionUnreturnedAmounts,
  dispatchClearUnreturnedAmounts: clearUnreturnedAmounts,
};

export default connect(mapStateToProps, mapDispatchToProps)(UnreturnedAmountTable);
